export default __webpack_public_path__ + "static/media/spinner.8cb3a090.gif";